import $ from 'jquery';

(() => {
  const idleClass = 'fa-light fa-copy cursor-pointer ml-2'
  const activeClass = 'fa-light fa-check text-success ml-2'

  $(document).on('click', '[data-copy] i.fa-copy', function () {
    const $this = $(this)
    const text = $(this).closest('[data-copy]').text()

    if (text) {
      navigator.clipboard.writeText(text.trim());

      $this.removeClass(idleClass)
      $this.addClass(activeClass)
      setTimeout(() => {
        $this.removeClass(activeClass)
        $this.addClass(idleClass)
      }, 1000)
    }
  })

  function addIcon() {
    const icon = $("<i></i>").addClass(idleClass).attr("title", "Copiar");
    $('[data-copy]:not(:empty):not(:has(i.fa-copy)').append(icon);
  }

  $(document).on('turbo:render', addIcon)
  $(addIcon)
})();